/* WEBPACK IMPORT JS IN THIS FILE */
var au = document.querySelectorAll('.ck24-author-info');
window.fireOnVisible(au, async () => {
    await import('./assets/css/wt-authorinfo.scss');
});
